
/**
 * Модель компании, для которой ещё не назначен level.
 */
export class PendingCompanyLevel {
    constructor({
      id = null,
      companyId = null,
      companyName = null,
      workerId = null,
      level = null,
      isCurrentEmployee = null
    } = {}) {
      this.id = id;
      this.companyId = companyId;
      this.companyName = companyName;
      this.workerId = workerId;
      this.level = level;
      this.isCurrentEmployee = isCurrentEmployee;
    }
  
    static fromJson(json) {
      if (!json || typeof json !== "object") {
        return null;
      }
  
      return new PendingCompanyLevel({
        id: json.id ?? null,
        companyId: json.companyId ?? null,
        companyName: json.companyName ?? null,
        workerId: json.workerId ?? null,
        level: json.level ?? null,
        isCurrentEmployee: json.isCurrentEmployee ?? null
      });
    }
  }
  
  /**
   * Ответ Firebase Cloud Function:
   * get_pending_level_for_company
   */
  export default class PendingCompanyLevelResponse {
    constructor({
      success = false,
      companyEmployee = null,
      error = null
    } = {}) {
      this.success = success;
      this.companyEmployee = companyEmployee;
      this.error = error;
    }
  
    static fromJson(json) {
      if (!json || typeof json !== "object") {
        throw new Error("Invalid PendingCompanyLevelResponse");
      }
  
      return new PendingCompanyLevelResponse({
        success: json.success === true,
  
        companyEmployee: PendingCompanyLevel.fromJson(
          json.companyEmployee
        ),
  
        error: json.error ?? null
      });
    }
  
    /**
     * Есть ли компания, ожидающая назначения level.
     */
    get hasPendingCompany() {
      return (
        this.success &&
        this.companyEmployee !== null &&
        this.companyEmployee.level === null
      );
    }
  }
  